export const withVar = (token: string): string => `var(${token})`
